import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';
import { useState, useEffect } from "react";
import { supabase } from "../../lib/supabaseClient";
import styles from '../../styles/GridLayout.module.css';
import Link from 'next/link';
import CanvasGrid from "../../src/components/CanvasGrid";
import MobileCanvas from "../../src/components/MobileCanvas";
import { GameList } from "../list/GameList";
import { Assets } from "../list/Assets";

const Ad_120x600 = dynamic(() => import('../../src/ads/Ad_120x600'), {
  ssr: false,
  loading: () => <p>Loading Ad...</p>,
});
const Ad_300x250_1 = dynamic(() => import('../../src/ads/Ad_300x250_1'), {
  ssr: false,
  loading: () => <p>Loading Ad...</p>,
});
const Ad_300x250_2 = dynamic(() => import('../../src/ads/Ad_300x250_2'), {
  ssr: false,
  loading: () => <p>Loading Ad...</p>,
});
const Ad_728x90 = dynamic(() => import('../../src/ads/Ad_728x90'), {
  ssr: false,
  loading: () => <p>Loading Ad...</p>,
});
const Ad_728x90_Bot = dynamic(() => import('../../src/ads/Ad_728x90_Bot'), {
  ssr: false,
  loading: () => <p>Loading Ad...</p>,
});

const GridLayout = ({ items,mOncliock }) => {
  const router = useRouter();
  const pathName = router.query.id;
  const [isSmall, setSmall] = useState(false);
  const [mobile, setMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
      setMobile(isMobile);
      setSmall(window.innerWidth < 300 || isMobile);
    };

    // Set initial states
    handleResize();

    // Add event listener
    window.addEventListener('resize', handleResize);

    // Cleanup event listener on unmount
    return () => window.removeEventListener('resize', handleResize);
  }, []); // Empty dependency array ensures this runs once on mount and cleanup on unmount

  
  
  const [game, setGame] = useState(null);
  useEffect(() => {
    if (pathName) {
      supabase.from('bestgamespot_games').select('*').eq('slug', pathName).single().then(({data}) => {
         if(data) {
           setGame({
             brand: data.brand,
             iframe: data.iframe,
             name: [data.title, data.slug],
             thumb: data.thumb
           });
         }
      });
    }
  }, [pathName]);
  
  function setIframe() {
    return game;
  }
  

  return (
    <div className={styles.gridContainer}>
    
    <div className={`${styles.gridItem} ${styles.MediumBanner}`}
          >
            <Ad_300x250_1/>
            <Ad_300x250_2/>
            
          </div>

          <div className={`${styles.gridItem} ${styles.Wide_Skyscraper}`}
          ><Ad_120x600/></div>
    <div className={`${styles.gridItem} ${styles.specialItem}`}
    
          > 
         
            {!isSmall && (
            <CanvasGrid
            brand={setIframe()?.brand}
            iframe={setIframe()?.iframe}
            name={setIframe()?.name[0]}
            src={Assets[0].f_icon}
            />
          )}
          {isSmall && (
            <MobileCanvas
              thumb={setIframe()?.thumb}
              name={setIframe()?.name[0]}
              onClick={mOncliock}
            />
          )}
          
          </div>
        
<div className={`${styles.gridItem} ${styles.Wide_Skyscraper2}`}
          ><Ad_120x600/></div>
         <div className={`${styles.gridItem} ${styles.Leaderboard}`}
          ><Ad_728x90/></div>
         
      {Object.entries(items).map(([category, url], index) => (
        // Leaderboard
          <div key={index}>
          </div>
      ))}
    </div>
  );
};

export default GridLayout;
